export default {
  CREATE: 'suggestions/CREATE',
  UPDATE: 'suggestions/UPDATE',
  CLEAR_ALL: 'suggestions/CLEAR_ALL'
};
